export const SET_SEARCH = 'SET_SEARCH';
export const RESET_SEARCH = 'RESET_SEARCH';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
